export default __webpack_public_path__ + "static/media/Camera-bro.e470050c.svg";